import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import {
  ArchiveHero,
  ArchiveMenu,
  ArchiveSticky,
  Champion,
  Footer,
  Header
} from "../components";
import { ChampionData } from "../components/ChampionData";
import Vote from "../images/H2_Large_Vote.svg";
import Menu from "../images/Menu.svg";

const years = Object.values(ChampionData).map((x) => x.year);

const Archive = () => {
  const [stickyHeight, setStickyHeight] = useState(0);

  return (
    <div className="Archive bg-hugepurple text-white">
      <div className="container">
        <Header />
        <ArchiveHero />
      </div>
      <ArchiveSticky
        years={years}
        onSize={(size) => {
          setStickyHeight(size.height);
        }}
        onStateChange={(height) => {
          setStickyHeight(height);
        }}
      />
      <ChampionsSection height={stickyHeight} />
      <div id="stop-sticky" className="lg:block lg:-mt-32"/>
      <Footer label="If you haven't done this yet, you better.">
        <Link to="/">
          <img
            src={Vote}
            alt="Vote"
            className="p-8 transition-colors duration-200 hover:bg-hugeorange"
          />
        </Link>
      </Footer>
      <MobileStickyMenu />
    </div>
  );
};

function ChampionsSection({ height }) {
  const ids = Object.keys(ChampionData || {});
  return (
    <div style={{ marginTop: -height || 0 }}>
      {ids.map((id) => {
        const { year, image, champion, placements, team } = ChampionData[id];
        return (
          <Champion
            key={year + "-" + id}
            year={year}
            years={years}
            image={image}
            champion={champion}
            placements={placements}
            team={team}
          />
        );
      })}
    </div>
  );
}

function MobileStickyMenu() {
  const [menuOpen, setMenuOpen] = React.useState(false);
  return (
    <>
      <CSSTransition
        unmountOnExit
        in={menuOpen}
        timeout={300}
        classNames="archive-menu"
      >
        <ArchiveMenu years={years} onClose={() => setMenuOpen(false)} />
      </CSSTransition>
      <img
        src={Menu}
        alt="Menu"
        className="fixed bottom-0 right-0 z-40 mr-3 mb-3 lg:hidden"
        onClick={() => {
          setMenuOpen(true);
        }}
      />
    </>
  );
}

export default Archive;
